// import React, { useRef } from "react";

// import { useNavigate } from "react-router-dom";

// // import "../App.css";
// import "../../index.css";
// import "tachyons";
// import "./home.css"
// import AnimatedServices from "./AnimatedServices";

// function Home() {
//   const navigate = useNavigate();


//   return (
//     <div className="App bg-black  ">
//       <div className="section-hero pt4  ">
//         <h2 className="hero__heading ml4 mr4 ">
//           Welcome to
//           <span> Terraweb</span>
//         </h2>
//         <p className="hero__paragraph">
//           "Building <span>Bonds</span>
//           Beyond <span>Boundaries"</span>
//         </p>
//         <div className="hero__buttons">
//           <button className="btn btn-orange br-pill f3" onClick={() => navigate("/login")}>
//             <label onClick={() => navigate("/login")} className="link-orange">
//               Sign In
//             </label>
//           </button>
//           <button className="btn btn-white br-pill f3" onClick={() => navigate("/register")}>
//             <label onClick={() => navigate("/register")} className="link-white">
//               Sign Up
//             </label>
//           </button>
//         </div>
//       </div>

//       <div className="about-section container">
//         <img
//           src="/img/LOGO-FAVCON.png"
//           alt="terraweb logo"
//           className="about-section__image"
//         />
//         <div className="about-section__text white">
//           <h3 className="about-section__text--heading">Terrawebgroup</h3>
//           <p className="about-section__text--paragraph white">
//             We are a local youth group driven by a vision and ambition to build
//             bonds through data processing, analyzing and communication using
//             technology in order to enhance, empower and connect.
//           </p>
//         </div>
//       </div>

//       {/* <div className="services-section">
//          <div className="container services">
//           <div className="servicees__service">
//             <h3 className="services__service--title">Services</h3>
//             <p className="services__service--text">
//               <ul className="ml-20">
//                 <li>Data processing</li>
//                 <li>Cloud data management</li>
//                 <li>Information communication</li>
//                 <li>Agricultural e-learning</li>
//               </ul>
//             </p>
//           </div>
//           <div className="servicees__service">
//             <h3 className="services__service--title">Vision</h3>
//             <p className="services__service--text">
//               To nurture a winning network by building bonds for long-term value,
//               in the value chain.
//             </p>
//           </div>
//           <div className="servicees__service">
//             <h3 className="services__service--title">Mission</h3>
//             <p className="services__service--text">
//               To enhance, empower and connect through technology to create worth
//               and make a distinction.
//             </p>
//           </div>
//           <div className="servicees__service">
//             <h3 className="services__service--title">AIMS</h3>
//             <p className="services__service--text">
//               To build bonds through technology in order to create worth in the
//               Value chain network.
//             </p>
//           </div>
//         </div>
//       </div> */}

//       {/* new AI2 */}
//   <AnimatedServices/>


//     </div>
//   );
// }

// export default Home;


// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import "tachyons";
// import "./landing.css";

// // Adjust these to your real routes
// const ROUTES = { signin: "/signin", signup: "/signup" };
// const WHATSAPP = "https://wa.me/254700000000"; // replace with your number
// const DEMO_HREF = "#demo";

// const NAV = [
//   ["Features", "#features"],
//   ["Who we serve", "#serve"],
//   ["How it works", "#steps"],
//   ["Contact", "#demo"],
// ];

// const P = {
//   shield: <><path d="M12 3l8 3v6c0 4.5-3.2 8.2-8 9-4.8-.8-8-4.5-8-9V6z" /><path d="M9 12l2 2 4-4" /></>,
//   pin: <><path d="M12 21s-6-5.6-6-10a6 6 0 1112 0c0 4.4-6 10-6 10z" /><circle cx="12" cy="11" r="2.2" /></>,
//   bolt: <path d="M13 3L5 14h6l-1 7 8-11h-6z" />,
//   database: <><ellipse cx="12" cy="6" rx="7" ry="3" /><path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6" /><path d="M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" /></>,
//   eye: <><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
//   users: <><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" /><circle cx="17" cy="9" r="2.4" /><path d="M17 14c2.5 0 4.5 2 4.5 4.5" /></>,
//   file: <><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5M10 13h6M10 17h6" /></>,
//   lock: <><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 018 0v3" /></>,
//   chart: <><path d="M3 20h18" /><path d="M6 16l4-5 3 3 5-7" /></>,
//   drop: <path d="M12 3s6 6.5 6 11a6 6 0 11-12 0c0-4.5 6-11 6-11z" />,
//   leaf: <><path d="M5 19c0-8 5-14 14-14 0 9-6 14-14 14z" /><path d="M5 19l8-8" /></>,
//   truck: <><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z" /><circle cx="7" cy="18" r="1.8" /><circle cx="17" cy="18" r="1.8" /></>,
//   search: <><circle cx="11" cy="11" r="6" /><path d="M16 16l5 5" /></>,
//   calendar: <><rect x="4" y="5" width="16" height="16" rx="2" /><path d="M4 10h16M9 3v4M15 3v4" /></>,
//   user: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" /></>,
// };

// function Icon({ name }) {
//   return (
//     <svg className="tw-ic" viewBox="0 0 24 24" aria-hidden="true">
//       {P[name]}
//     </svg>
//   );
// }

// const STATS = [
//   { label: "Farmers", value: "1,248", delta: "+12% vs last month" },
//   { label: "Collection (L)", value: "45,678", delta: "+8% vs last month" },
//   { label: "Routes", value: "24", delta: "Active" },
//   { label: "Today (L)", value: "12,450", delta: "Updated 10:30 AM" },
// ];

// const ACTIVITY = [
//   ["New farmer added", "2 mins ago", "orange"],
//   ["Collection recorded", "15 mins ago", "green"],
//   ["Payment completed", "1 hour ago", "orange"],
//   ["Route updated", "2 hours ago", "blue"],
// ];

// const TREND = [14, 22, 18, 30, 26, 40, 46, 58, 54, 70];

// const BENEFITS = [
//   ["Better records", "Keep farmer and operational data in one secure place.", "database"],
//   ["Better visibility", "See what is happening across routes, centres and farmers.", "eye"],
//   ["Better coordination", "Keep teams and farmers connected to the right information.", "users"],
//   ["Better reporting", "Generate accurate reports and statements in minutes.", "file"],
//   ["Better control", "Manage access and protect your organization's data.", "lock"],
//   ["Better decisions", "Use real data to plan, negotiate and grow.", "chart"],
// ];

// const SERVE = [
//   { title: "Dairy cooperatives", text: "Manage farmers, milk collection, production and payments efficiently.", tone: "tw-tone-1", icon: "drop" },
//   { title: "Agricultural cooperatives", text: "Organize members, activities and records for better management.", tone: "tw-tone-2", icon: "leaf" },
//   { title: "Agribusinesses", text: "Streamline operations and improve data-driven performance.", tone: "tw-tone-3", icon: "truck" },
//   { title: "Producer organizations", text: "Give members information that drives better outcomes.", tone: "tw-tone-4", icon: "users" },
// ];

// const STEPS = [
//   ["Discover", "We learn how you collect, manage and use data today.", "search"],
//   ["Book a demo", "See the platform in action and ask the right questions.", "calendar"],
//   ["Get onboarded", "We set you up and train your team for success.", "user"],
//   ["Grow together", "Use your data to run operations and plan with confidence.", "chart"],
// ];

// function Chart() {
//   const w = 300;
//   const h = 110;
//   const max = Math.max(...TREND);
//   const pts = TREND.map(
//     (v, i) => `${(i / (TREND.length - 1)) * w},${h - (v / max) * (h - 12) - 4}`
//   ).join(" ");
//   return (
//     <svg
//       viewBox={`0 0 ${w} ${h}`}
//       className="tw-chart"
//       role="img"
//       aria-label="Collection trend rising over the past month"
//     >
//       {[0.25, 0.5, 0.75].map((g) => (
//         <line key={g} x1="0" x2={w} y1={h * g} y2={h * g} className="tw-grid" />
//       ))}
//       <polyline points={pts} fill="none" className="tw-line" />
//     </svg>
//   );
// }

// function DashboardMock() {
//   return (
//     <div className="tw-mock" aria-hidden="true">
//       <div className="tw-mock-top">
//         <strong>Dashboard</strong>
//         <span className="tw-mock-user">John Maina · Admin</span>
//       </div>
//       <div className="tw-mock-stats">
//         {STATS.map((s) => (
//           <div key={s.label} className="tw-mock-stat">
//             <small>{s.label}</small>
//             <b>{s.value}</b>
//             <em>{s.delta}</em>
//           </div>
//         ))}
//       </div>
//       <div className="tw-mock-body">
//         <div className="tw-mock-panel">
//           <small>Collection trend (litres)</small>
//           <Chart />
//         </div>
//         <div className="tw-mock-panel">
//           <small>Recent activities</small>
//           <ul className="tw-activity">
//             {ACTIVITY.map(([t, when, c]) => (
//               <li key={t}>
//                 <i className={`tw-dot tw-dot-${c}`} />
//                 <span>
//                   {t}
//                   <br />
//                   <em>{when}</em>
//                 </span>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function Homepage() {
//   const [open, setOpen] = useState(false);
//   const close = () => setOpen(false);

//   return (
//     <div className="tw">
//       {/* NAV: sign in / sign up live here, on every screen size */}
//       <header className="tw-nav">
//         <div className="tw-wrap tw-nav-row">
//           <a href="#top" className="tw-brand" onClick={close}>
//             <img src="/img/LOGO-FAVCON.png" alt="" width="32" height="32" />
//             <span>Terraweb</span>
//           </a>

//           <nav className="tw-links" aria-label="Main">
//             {NAV.map(([label, href]) => (
//               <a key={label} href={href}>
//                 {label}
//               </a>
//             ))}
//           </nav>

//           <div className="tw-auth">
//             <Link to={ROUTES.signin} className="tw-btn tw-btn-ghost">
//               Sign in
//             </Link>
//             <Link to={ROUTES.signup} className="tw-btn tw-btn-solid">
//               Sign up
//             </Link>
//           </div>

//           <button
//             type="button"
//             className="tw-burger"
//             aria-label={open ? "Close menu" : "Open menu"}
//             aria-expanded={open}
//             aria-controls="tw-menu"
//             onClick={() => setOpen((o) => !o)}
//           >
//             <span />
//             <span />
//             <span />
//           </button>
//         </div>

//         {open && (
//           <div id="tw-menu" className="tw-menu">
//             {NAV.map(([label, href]) => (
//               <a key={label} href={href} onClick={close}>
//                 {label}
//               </a>
//             ))}
//             <div className="tw-menu-auth">
//               <Link to={ROUTES.signin} className="tw-btn tw-btn-ghost" onClick={close}>
//                 Sign in
//               </Link>
//               <Link to={ROUTES.signup} className="tw-btn tw-btn-solid" onClick={close}>
//                 Sign up
//               </Link>
//             </div>
//           </div>
//         )}
//       </header>

//       {/* HERO */}
//       <section id="top" className="tw-hero">
//         <div className="tw-wrap tw-hero-grid">
//           <div className="tw-hero-copy">
//             <p className="tw-pill">Built for agriculture. Designed for impact.</p>
//             <h1>
//               Turn your data <span>your power.</span>
//             </h1>
//             <p className="tw-lead">
//               TerraWeb helps cooperatives and agribusinesses collect, manage and
//               use their data to run operations better and grow with confidence.
//             </p>
//             <div className="tw-cta">
//               <a href={DEMO_HREF} className="tw-btn tw-btn-solid tw-btn-lg">
//                 Book a free demo
//               </a>
//               <a
//                 href={WHATSAPP}
//                 target="_blank"
//                 rel="noreferrer"
//                 className="tw-btn tw-btn-ghost tw-btn-lg"
//               >
//                 Talk to us on WhatsApp
//               </a>
//             </div>
//             <ul className="tw-assure">
//               <li>
//                 <Icon name="shield" />
//                 <span><b>Secure and reliable</b>Your data is protected</span>
//               </li>
//               <li>
//                 <Icon name="pin" />
//                 <span><b>Built in Kenya</b>For local realities</span>
//               </li>
//               <li>
//                 <Icon name="bolt" />
//                 <span><b>Easy to use</b>For every team</span>
//               </li>
//             </ul>
//           </div>
//           <DashboardMock />
//         </div>
//       </section>

//       {/* BENEFITS */}
//       <section id="features" className="tw-benefits">
//         <div className="tw-wrap">
//           <ul className="tw-benefit-grid">
//             {BENEFITS.map(([t, d, ic]) => (
//               <li key={t}>
//                 <Icon name={ic} />
//                 <h3>{t}</h3>
//                 <p>{d}</p>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </section>

//       {/* WHO WE SERVE */}
//       <section id="serve" className="tw-section">
//         <div className="tw-wrap">
//           <h2 className="tw-h2">Built for organizations that grow together.</h2>
//           <p className="tw-sub">
//             Designed for the realities of agricultural operations in Mt. Kenya
//             and beyond.
//           </p>
//           <div className="tw-serve-grid">
//             {SERVE.map((s) => (
//               <article key={s.title} className="tw-card">
//                 {/* swap the gradient for a photo: style={{backgroundImage:"url(/img/landing/dairy.jpg)"}} */}
//                 <div className={`tw-card-img ${s.tone}`} />
//                 <span className="tw-badge">
//                   <Icon name={s.icon} />
//                 </span>
//                 <div className="tw-card-body">
//                   <h3>{s.title}</h3>
//                   <p>{s.text}</p>
//                   <a href={DEMO_HREF}>Learn more</a>
//                 </div>
//               </article>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* STEPS */}
//       <section id="steps" className="tw-section tw-section-alt">
//         <div className="tw-wrap">
//           <h2 className="tw-h2">Getting started is simple.</h2>
//           <ol className="tw-steps">
//             {STEPS.map(([t, d, ic], i) => (
//               <li key={t}>
//                 <div className="tw-step-head">
//                   <span className="tw-step-n">{i + 1}</span>
//                   <Icon name={ic} />
//                 </div>
//                 <h3>{t}</h3>
//                 <p>{d}</p>
//               </li>
//             ))}
//           </ol>
//         </div>
//       </section>

//       {/* FINAL CTA */}
//       <section id="demo" className="tw-final">
//         <div className="tw-wrap">
//           <h2>See TerraWeb run on your own data.</h2>
//           <p>Book a 30-minute walkthrough, or start with an account today.</p>
//           <div className="tw-cta tw-cta-center">
//             <a href={WHATSAPP} target="_blank" rel="noreferrer" className="tw-btn tw-btn-solid tw-btn-lg">
//               Book a free demo
//             </a>
//             <Link to={ROUTES.signin} className="tw-btn tw-btn-ghost tw-btn-lg">
//               Sign in
//             </Link>
//             <Link to={ROUTES.signup} className="tw-btn tw-btn-ghost tw-btn-lg">
//               Sign up
//             </Link>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// }




import React, { useState } from "react";
import { Link } from "react-router-dom";
import "tachyons";
import "./landing.css";

// Adjust these to your real routes
const ROUTES = { signin: "/login", signup: "/register" };
const WHATSAPP = "https://wa.me/254740401492"; // replace with your number
const DEMO_HREF = "#demo";

const NAV = [
  ["Features", "#features"],
  ["Who we serve", "#serve"],
  ["How it works", "#steps"],
  ["Contact", "#demo"],
];

const P = {
  shield: <><path d="M12 3l8 3v6c0 4.5-3.2 8.2-8 9-4.8-.8-8-4.5-8-9V6z" /><path d="M9 12l2 2 4-4" /></>,
  pin: <><path d="M12 21s-6-5.6-6-10a6 6 0 1112 0c0 4.4-6 10-6 10z" /><circle cx="12" cy="11" r="2.2" /></>,
  bolt: <path d="M13 3L5 14h6l-1 7 8-11h-6z" />,
  database: <><ellipse cx="12" cy="6" rx="7" ry="3" /><path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6" /><path d="M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" /></>,
  eye: <><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
  users: <><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" /><circle cx="17" cy="9" r="2.4" /><path d="M17 14c2.5 0 4.5 2 4.5 4.5" /></>,
  file: <><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5M10 13h6M10 17h6" /></>,
  lock: <><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 018 0v3" /></>,
  chart: <><path d="M3 20h18" /><path d="M6 16l4-5 3 3 5-7" /></>,
  drop: <path d="M12 3s6 6.5 6 11a6 6 0 11-12 0c0-4.5 6-11 6-11z" />,
  leaf: <><path d="M5 19c0-8 5-14 14-14 0 9-6 14-14 14z" /><path d="M5 19l8-8" /></>,
  truck: <><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z" /><circle cx="7" cy="18" r="1.8" /><circle cx="17" cy="18" r="1.8" /></>,
  search: <><circle cx="11" cy="11" r="6" /><path d="M16 16l5 5" /></>,
  calendar: <><rect x="4" y="5" width="16" height="16" rx="2" /><path d="M4 10h16M9 3v4M15 3v4" /></>,
  grid: <><rect x="4" y="4" width="7" height="7" rx="1.5" /><rect x="13" y="4" width="7" height="7" rx="1.5" /><rect x="4" y="13" width="7" height="7" rx="1.5" /><rect x="13" y="13" width="7" height="7" rx="1.5" /></>,
  bell: <><path d="M6 16V11a6 6 0 1112 0v5l2 2H4z" /><path d="M10 21h4" /></>,
  wallet: <><rect x="3" y="6" width="18" height="14" rx="2" /><path d="M3 10h18M16 15h2" /></>,
  msg: <path d="M4 5h16v11H9l-5 4z" />,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" /></>,
};

function Icon({ name }) {
  return (
    <svg className="tw-ic" viewBox="0 0 24 24" aria-hidden="true">
      {P[name]}
    </svg>
  );
}

const STATS = [
  { label: "Farmers", value: "1,248", delta: "+12% vs last month" },
  { label: "Collection (L)", value: "45,678", delta: "+8% vs last month" },
  { label: "Routes", value: "24", delta: "Active" },
  { label: "Today (L)", value: "12,450", delta: "Updated 10:30 AM" },
];

const ACTIVITY = [
  ["New farmer added", "2 mins ago", "orange"],
  ["Collection recorded", "15 mins ago", "green"],
  ["Payment completed", "1 hour ago", "orange"],
  ["Route updated", "2 hours ago", "blue"],
];

const MENU = [
  ["Dashboard", "grid"], ["Farmers", "user"], ["Collection", "drop"],
  ["Production", "leaf"], ["Routes", "pin"], ["Payments", "wallet"],
  ["Reports", "file"], ["Messages", "msg"], ["Users", "users"], ["Settings", "settings"],
];

const TREND = [14, 22, 18, 30, 26, 40, 46, 58, 54, 70];

const BENEFITS = [
  ["Better records", "Keep farmer and operational data in one secure place.", "database"],
  ["Better visibility", "See what is happening across routes, centres and farmers.", "eye"],
  ["Better coordination", "Keep teams and farmers connected to the right information.", "users"],
  ["Better reporting", "Generate accurate reports and statements in minutes.", "file"],
  ["Better control", "Manage access and protect your organization's data.", "lock"],
  ["Better decisions", "Use real data to plan, negotiate and grow.", "chart"],
];

const SERVE = [
  { title: "Dairy cooperatives", image: "/img/dairy.jpg", text: "Manage farmers, milk collection, production and payments efficiently.", tone: "tw-tone-1", icon: "drop" },
  { title: "Agricultural cooperatives", image: "/img/coffeebean.jpg", text: "Organize members, activities and records for better management.", tone: "tw-tone-2", icon: "leaf" },
  { title: "Agribusinesses", image: "/img/hero.jpg", text: "Streamline operations and improve data-driven performance.", tone: "tw-tone-3", icon: "truck" },
  { title: "Producer organizations", image: "/img/cowgirl.jpeg", text: "Give members information that drives better outcomes.", tone: "tw-tone-4", icon: "users" },
];

const STEPS = [
  ["Discover", "We learn how you collect, manage and use data today.", "search"],
  ["Book a demo", "See the platform in action and ask the right questions.", "calendar"],
  ["Get onboarded", "We set you up and train your team for success.", "user"],
  ["Grow together", "Use your data to run operations and plan with confidence.", "chart"],
];

function Chart() {
  const w = 300;
  const h = 110;
  const max = Math.max(...TREND);
  const pts = TREND.map(
    (v, i) => `${(i / (TREND.length - 1)) * w},${h - (v / max) * (h - 12) - 4}`
  ).join(" ");
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      className="tw-chart"
      role="img"
      aria-label="Collection trend rising over the past month"
    >
      {[0.25, 0.5, 0.75].map((g) => (
        <line key={g} x1="0" x2={w} y1={h * g} y2={h * g} className="tw-grid" />
      ))}
      <polyline points={pts} fill="none" className="tw-line" />
    </svg>
  );
}

function DashboardMock() {
  return (
    <div className="tw-mock" aria-hidden="true">
      <aside className="tw-side">
        <div className="tw-side-brand">
          <img src="/img/LOGO-FAVCON.png" alt="" width="22" height="22" />
          <b>TERRAWEB</b>
        </div>
        <ul>
          {MENU.map(([label, ic], i) => (
            <li key={label} className={i === 0 ? "is-on" : ""}>
              <Icon name={ic} />
              <span>{label}</span>
            </li>
          ))}
        </ul>
      </aside>

      <div className="tw-main">
        <div className="tw-mock-top">
          <strong>Dashboard</strong>
          <span className="tw-mock-user">
            <Icon name="bell" />
            <i className="tw-avatar">JM</i>
            <span className="tw-who">John Maina<br /><em>Admin</em></span>
          </span>
        </div>
        <div className="tw-mock-stats">
          {STATS.map((s) => (
            <div key={s.label} className="tw-mock-stat">
              <small>{s.label}</small>
              <b>{s.value}</b>
              <em>{s.delta}</em>
            </div>
          ))}
        </div>
        <div className="tw-mock-body">
          <div className="tw-mock-panel">
            <small>Collection trend (litres)</small>
            <Chart />
          </div>
          <div className="tw-mock-panel">
            <small>Recent activities</small>
            <ul className="tw-activity">
              {ACTIVITY.map(([t, when, c]) => (
                <li key={t}>
                  <i className={`tw-dot tw-dot-${c}`} />
                  <span>
                    {t}
                    <br />
                    <em>{when}</em>
                  </span>
                </li>
              ))}
            </ul>
            <span className="tw-viewall">View all</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Homepage() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <div className="tw">
      {/* NAV: sign in / sign up live here, on every screen size */}
      <header className="tw-nav">
        {/* <div className="tw-wrap tw-nav-row">
          <a href="#top" className="tw-brand" onClick={close}>
            <img src="/img/LOGO-FAVCON.png" alt="" width="32" height="32" />
            <span>Terraweb</span>
          </a>

          <nav className="tw-links" aria-label="Main">
            {NAV.map(([label, href]) => (
              <a key={label} href={href}>
                {label}
              </a>
            ))}
          </nav>

          <div className="tw-auth">
            <Link to={ROUTES.signin} className="tw-btn tw-btn-ghost">
              Sign in
            </Link>
            <Link to={ROUTES.signup} className="tw-btn tw-btn-solid">
              Sign up
            </Link>
          </div>

          <button
            type="button"
            className="tw-burger"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            aria-controls="tw-menu"
            onClick={() => setOpen((o) => !o)}
          >
            <span />
            <span />
            <span />
          </button>
        </div> */}

        {open && (
          <div id="tw-menu" className="tw-menu">
            {NAV.map(([label, href]) => (
              <a key={label} href={href} onClick={close}>
                {label}
              </a>
            ))}
            <div className="tw-menu-auth">
              <Link to={ROUTES.signin} className="tw-btn tw-btn-ghost" onClick={close}>
                Sign in
              </Link>
              <Link to={ROUTES.signup} className="tw-btn tw-btn-solid" onClick={close}>
                Sign up
              </Link>
            </div>
          </div>
        )}
      </header>

      {/* HERO */}
      {/* <section id="top" className="tw-hero"> */}

      <section id="top" className="tw-hero" style={{ "--hero-img": "url(/img/hero.jpg)" }}>
        <div className="tw-wrap tw-hero-grid">
          <div className="tw-hero-copy">
            <p className="tw-pill">Built for agriculture. Designed for impact.</p>
            <h1>
              Turn your data <span>your power.</span>
            </h1>
            <p className="tw-lead">
              TerraWeb helps cooperatives and agribusinesses collect, manage and
              use their data to run operations better and grow with confidence.
            </p>
            <div className="tw-cta">
              <a href={DEMO_HREF} className="tw-btn tw-btn-solid tw-btn-lg">
                Book a free demo
              </a>
              <a
                href={WHATSAPP}
                target="_blank"
                rel="noreferrer"
                className="tw-btn tw-btn-ghost tw-btn-lg"
              >
                Talk to us on WhatsApp
              </a>
               <Link to={ROUTES.signin} className="tw-btn tw-btn-ghost tw-btn-lg">
              Sign in
            </Link>
            <Link to={ROUTES.signup} className="tw-btn tw-btn-ghost tw-btn-lg">
              Sign up
            </Link>
            </div>
            <ul className="tw-assure">
              <li>
                <Icon name="shield" />
                <span><b>Secure and reliable</b>Your data is protected</span>
              </li>
              <li>
                <Icon name="pin" />
                <span><b>Built in Kenya</b>For local realities</span>
              </li>
              <li>
                <Icon name="bolt" />
                <span><b>Easy to use</b>For every team</span>
              </li>
            </ul>
          </div>
          <DashboardMock />
        </div>
      </section>

      {/* BENEFITS */}
      <section id="features" className="tw-benefits">
        <div className="tw-wrap">
          <ul className="tw-benefit-grid">
            {BENEFITS.map(([t, d, ic]) => (
              <li key={t}>
                <Icon name={ic} />
                <h3>{t}</h3>
                <p>{d}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* WHO WE SERVE */}
      <section id="serve" className="tw-section">
        <div className="tw-wrap">
          <h2 className="tw-h2">Built for organizations that grow together.</h2>
          <p className="tw-sub">
            Designed for the realities of agricultural operations in Mt. Kenya
            and beyond.
          </p>
          <div className="tw-serve-grid">
            {SERVE.map((s) => (
              <article key={s.title} className="tw-card">
                {/* swap the gradient for a photo: style={{backgroundImage:"url(/img/landing/dairy.jpg)"}} */}
                <div
                  className={`tw-card-img ${s.tone}`}
                  style={{ "--img": `url(${s.image})` }}
                />
                <span className="tw-badge">
                  <Icon name={s.icon} />
                </span>
                <div className="tw-card-body">
                  <h3>{s.title}</h3>
                  <p>{s.text}</p>
                  <a href={DEMO_HREF}>Learn more</a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* STEPS */}
      <section id="steps" className="tw-section tw-section-alt">
        <div className="tw-wrap">
          <h2 className="tw-h2">Getting started is simple.</h2>
          <ol className="tw-steps">
            {STEPS.map(([t, d, ic], i) => (
              <li key={t}>
                <div className="tw-step-head">
                  <span className="tw-step-n">{i + 1}</span>
                  <Icon name={ic} />
                </div>
                <h3>{t}</h3>
                <p>{d}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* FINAL CTA */}
      <section id="demo" className="tw-final">
        <div className="tw-wrap">
          <h2>See TerraWeb run on your own data.</h2>
          <p>Book a 30-minute walkthrough, or start with an account today.</p>
          <div className="tw-cta tw-cta-center">
            <a href={WHATSAPP} target="_blank" rel="noreferrer" className="tw-btn tw-btn-solid tw-btn-lg">
              Book a free demo
            </a>
            <Link to={ROUTES.signin} className="tw-btn tw-btn-ghost tw-btn-lg">
              Sign in
            </Link>
            <Link to={ROUTES.signup} className="tw-btn tw-btn-ghost tw-btn-lg">
              Sign up
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}